import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import './RepaymentPage.less';
import OneColumnLayout from '../../../../framework/components/Templates/OneColumnLayout/OneColumnLayout';
import BodyHeader from '../../../../shared-components/BodyHeader/BodyHeader';
import InstallmentSummary from '../../../components/InstallmentSummary/InstallmentSummary';
import { FIXED_APR } from '../../../config/DEConstants';
import PropTypes from 'prop-types';
import RepaymentPageForm from './RepaymentPageForm/RepaymentPageForm';
import SoftDeclineMessage from '../../../components/SoftDeclineMessage/SoftDeclineMessage';
import { trackTransition } from '../../../../framework/store/FPTI/FPTIActions';
import _ from 'lodash';

const LOCALE_PREFIX = 'DE/pages/RepaymentPage/RepaymentPage';


export class RepaymentPage extends Component {
    static propTypes = {
        intl: intlShape.isRequired,
        isAddBankSoftDecline: PropTypes.bool,
        apr: PropTypes.string,
        onComponentDidMount: PropTypes.func.isRequired
    };

    static defaultProps = {
        isAddBankSoftDecline: false,
        onComponentDidMount: () => {}
    };

    componentDidMount() {
        this.props.onComponentDidMount();
    }

    handleSubmit = () => {

    }

    showInstallmentSummaryHeader = () => {
        const { apr } = this.props;
        return +apr !== +FIXED_APR;
    };

    render() {
        const { intl, isAddBankSoftDecline } = this.props;

        return (
            <div id="RepaymentPageBox" className={isAddBankSoftDecline ? 'stickyHeader' : ''}>
                <OneColumnLayout pageName="RepaymentPage" className="RepaymentPageBox2">
                    <div className="repaymentHeader">
                        <BodyHeader />
                        {isAddBankSoftDecline ? <SoftDeclineMessage intl={intl} /> : null}
                    </div>
                    <div className="text-center">
                        <p className="vx_text-3 title">
                            <FormattedMessage className="alpha border-top" id={`${LOCALE_PREFIX}.bmlRepaymentPageTitle`} />
                        </p>
                    </div>

                    { this.showInstallmentSummaryHeader() ?
                        <p className="vx_text-legal header">
                            <FormattedMessage className="alpha border-top" id={`${LOCALE_PREFIX}.bmlRepaymentHeader`} />
                        </p>
                        : null}

                    <InstallmentSummary />
                    <RepaymentPageForm />
                </OneColumnLayout>
            </div>
        );
    }
}

export const mapStateToProps = state => ({
    isAddBankSoftDecline: _.get(state, 'serverData.isAddBankSoftDecline'),
    apr: _.get(state, 'serverData.financingDetails.apr', '')
});


export const mapDispatchToProps = dispatch => ({

    onComponentDidMount() {
        dispatch(trackTransition('pp_credit_repaymentpage', 'prepare_pp_credit_repaymentpage'));
    }

});


export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(RepaymentPage));
